import { ActionPointInfo, Controller, IActionPointInfo, Menu, Toolbar } from '@tencent/workbench';
import { BATCH_HANDLE_ANIMATION_CONFIGS, config, MENU_CONFIGS } from './config';
import { BatchHandleAnimationFeature } from './batch-handle-animation-feature';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Controller({
    toolbarItems: BATCH_HANDLE_ANIMATION_CONFIGS,
    menuItems: MENU_CONFIGS,
})
export class BatchHandleAnimationController {
    public constructor(private readonly feature: BatchHandleAnimationFeature) {
    }
    @Menu(config.id, 'content')
    public getPcBatchAnimationDropdownContent(@ActionPointInfo() batchAnimationInfo: IActionPointInfo) {
        return this.feature.getBatchHandleAnimation(batchAnimationInfo);
    }
    @Toolbar(config.id, 'dropdownContent')
    public getBatchAnimationDropdownContent(@ActionPointInfo() batchAnimationInfo: IActionPointInfo) {
        return this.feature.getBatchHandleAnimation(batchAnimationInfo);
    }
}
